import React, {Component} from 'react';
import { InputField } from '../../common/custom-form/input-filter-component';
import DATEPICKER_OR from '../../common/custom-form/custom-date-picker.component';
import Icon from '../../icon';
import { DataTable } from '../../common/table/data-table/data-table-component';
import ButtonIcon from '../../button';
import { TextArea } from '../../common/custom-form/custom-textarea.component';
import { Button } from 'react-bootstrap';
import { InvoiceLocation } from './invoice-location.component';
export default class LineItem extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue: "",
            beginDate: "",
            endDate: "",
            countLocation:1,
            dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ]
        }
    }

    getDataOnTable() {  
        this.props.getData(false);
    }

    addLocation() {
        this.setState({countLocation: this.state.countLocation + 1})
       
    }


    render(){
        return(
            <div className='manage-detail-container'>               
                <div className='close-button-detail-container'>
                    <Icon
                    customClassName="close-icon"
                    name="xmark"      
                    size="25px" 
                    onClick={this.getDataOnTable.bind(this)}
                    />
                </div>
                <div className='add-line-label'>
                    <span>Line Items Details</span>
                </div>
                <div className="manage-invoice-detail">
                    <DATEPICKER_OR label="BEGIN DATE" startDate={this.state.beginDate} dateSelected={this.state.beginDate} selectedDate={(date) => this.setState({beginDate:date})}/>
                    <InputField label="SUBSCRIPTION NUBER" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                  
                    <InputField customClass="grid-item-span-2" label="DESCRIPTION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <DATEPICKER_OR label="END DATE" startDate={this.state.endDate} dateSelected={this.state.endDate} selectedDate={(date) => this.setState({endDate:date})}/>
                    <InputField label="AMOUNT" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="NUMBER OF MILES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES PEAK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE MINUTES OFF PEAK" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="DATA ALLOCATED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PORT SPEED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="BTN" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE CALLS" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="USAGE DATA" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="OFF PEAK MINUTES" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="PEAK MINUTES/ALLOWED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CHARGE TYPE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                </div>
                <div className='add-line-label'>                   
                    <ButtonIcon onClick={this.addLocation.bind(this)} iconLeft="file-plus" iconSize="17px" customClassName="add-line-button" labelName="Add Location Item"/>                
                </div>                
                {[...Array(this.state.countLocation)].map((x,i) =>
                    <InvoiceLocation key={i} countLocation={i + 1}/>
                )}
                <div className='add-line-label'>
                    <span>Subline Item</span>  
                </div>
                {this.state.dataTable.map((item,id)=>
                    <DataTable key={id} id={id} item={item} header={item.HeaderItem} showSearchBox={true} data={item.dataItem} isDataLoaded={true} customClassName="table-container" />
                )} 
                <TextArea customClass="add-line-comment-text" label="Comment" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                <div className='add-line-item-button'>
                    <Button className="line-item-cancel-button"> Cancel </Button>
                    <Button className="line-item-save-button"> Save Line Item </Button>
                </div>
            </div>
        );
    }
}